<template>
  <div class="query-page">
      <h2 class="page-title">信息查询</h2>
      <!-- Filter Form -->
      <section class="filter-section">
        <el-form :inline="true" :model="filters" class="filter-form">
          <el-form-item label="村组">
            <el-select v-model="filters.groupName" placeholder="全部" clearable>
              <el-option v-for="g in groupOptions" :key="g.regioncode" :label="g.regionname" :value="g.regioncode" />
            </el-select>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="filters.name" placeholder="请输入姓名" clearable />
          </el-form-item>
          <el-form-item label="身份">
            <el-select v-model="filters.identity" placeholder="全部" clearable>
              <el-option label="房主" value="房主" />
              <el-option label="租户" value="租户" />
              <el-option label="九小场所" value="九小场所" />
            </el-select>
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input v-model="filters.phone" placeholder="请输入联系方式" clearable />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="filters.remark" placeholder="请输入备注关键词" clearable />
          </el-form-item>
          <el-form-item label="燃气厂家">
            <el-select v-model="filters.gasCompany" placeholder="全部" clearable>
              <el-option v-for="c in companyOptions" :key="c.name" :label="c.name" :value="c.name" />
            </el-select>
          </el-form-item>
          <el-form-item label="安心管">
            <el-select v-model="filters.safePipe" placeholder="全部" clearable>
              <el-option label="正常" value="0" />
              <el-option label="异常" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item label="操作员">
            <el-input v-model="filters.operator" placeholder="请输入操作员" clearable />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filters.status" placeholder="全部" clearable>
              <el-option label="正常" value="0" />
              <el-option label="异常" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="handleExport(1)" :loading="exporting">导出当前页</el-button>
            <el-button type="success" @click="handleExport(99999)" :loading="exporting">导出全部</el-button>
          </el-form-item>
        </el-form>
      </section>

      <!-- Table Section -->
      <section class="table-section">
        <el-table
          :data="filteredRecords"
          border
          stripe
          style="width: 100%"
          size="small"
          header-cell-class-name="table-header-cell"
        >
          <el-table-column prop="create_time" label="时间" width="150" />
          <el-table-column prop="regionname" label="组名" />
          <el-table-column prop="address_desc" label="地址" />
          <el-table-column prop="name" label="姓名" />
          <el-table-column prop="identity" label="身份" />
          <el-table-column prop="phone" label="联系方式" />
          <el-table-column prop="gas_supplier" label="燃气厂家" />
          <el-table-column label="安心管">
            <template slot-scope="scope">
              {{ scope.row.pipe_safe == '0' ? '正常' : '异常' }}
            </template>
          </el-table-column>
          <el-table-column label="照片" width="80">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.picpathlist && scope.row.picpathlist.length"
                style="width: 50px; height: 50px;"
                fit="cover"
                :src="scope.row.picpathlist[0]"
                :preview-src-list="scope.row.picpathlist"
              />
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip />
          <el-table-column prop="create_man" label="操作员" />
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.is_abnormal == '0' ? 'success' : 'danger'"
                size="small"
                effect="plain"
              >{{ scope.row.is_abnormal == '0' ? '正常' : '异常' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="update_time" label="整改时间"  width="150"  />
          <el-table-column
            fixed="right"
            label="操作"
            width="100">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">查看历史记录</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- Pagination -->
        <div class="pagination-wrapper">
          <el-pagination
            @current-change="goToPage"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalRecords"
          />
        </div>
      </section>
      <historylist ref="historylist"></historylist>
</div>
</template>

<script>
import historylist from './historylist.vue'
import { getUserpageList, getGasListFn, getCunZuYiChang } from '@/api/gasdashboard'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
export default {
  name: 'QueryPage',
  components: { historylist },
  data() {
    return {
      groupOptions: [],
      companyOptions: [],
      currentPage: 1,
      pageSize: 10,
      filters: {
        groupName: '',
        name: '',
        identity: '',
        phone: '',
        remark: '',
        gasCompany: '',
        safePipe: '',
        stove: '',
        operator: '',
        status: ''
      },
      allRecords: [],
      exporting: false,
      totalRecords: 0
    }
  },
  mounted() { 
    if(this.$route.query.regioncode){
      this.filters.groupName = this.$route.query.regioncode;
    }
    this.handleQuery();
    this.getGasList();
    this.getAllGroupInfo();
  },
  computed: {
    filteredRecords() {
      return this.allRecords
    }
  },
  methods: {
    
    handleClick(row) {
      this.$refs.historylist.dialogTableVisible = true;
      this.$refs.historylist.uuid = row.uuid;
      this.$refs.historylist.getUserHistoryList();
    },    handleQuery() {
      // Mock query action
      this.currentPage = 1;
      this.getUserList();
    },
    handleReset() {
      this.filters = {
        groupName: '',
        name: '',
        identity: '',
        phone: '',
        remark: '',
        gasCompany: '',
        safePipe: '',
        stove: '',
        operator: '',
        status: ''
      }
      this.currentPage = 1
    },
    goToPage(page) {
      if (page >= 1 && page <= Math.ceil(this.totalRecords / this.pageSize)) {
        this.currentPage = page
      }
      this.getUserList()
    },
    getUserList(){
        getUserpageList({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId(),
            page: this.currentPage,
            pagesize: this.pageSize,
            regioncode: this.filters.groupName,
            name: this.filters.name,
            identity: this.filters.identity,
            phone: this.filters.phone,
            remark: this.filters.remark,
            gas_supplier: this.filters.gasCompany,
            pipe_safe: this.filters.safePipe,
            create_man: this.filters.operator,
            is_abnormal: this.filters.status,
        }).then((res) => {
            if (res.result == '200') {
                this.totalRecords = res.detail.totalRow;
                this.allRecords = res.detail.list;
            } else {
                this.$message.error(res.description);
            }
        })
    },
    //获取小组的数据
    getAllGroupInfo() { 
         getCunZuYiChang({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId()
        }).then((res) => {
            if (res.result == '200') {
                let data = res.detail;
                this.groupOptions = data.map(item => { 
                  return {
                    regioncode: item.regioncode,
                    regionname: item.regionname
                  }
                });
            } else {
                this.$message.error(res.description);
            }
        })
    },
    //获取燃气列表
    getGasList() { 
        getGasListFn({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId(),
        }).then((res) => {
            if (res.result == '200') {
                this.companyOptions = res.detail;
            } else {
                this.$message.error(res.description);
            }
        })
    },
    //导出
    handleExport(num) {
      this.exporting = true;
      getUserpageList({
          'x-access-token': this.GLOBAL.token(),
          userid: this.GLOBAL.adminId(),
          page: this.currentPage,
          pagesize: num,
          regioncode: this.filters.groupName,
          name: this.filters.name,
          identity: this.filters.identity,
          phone: this.filters.phone,
          remark: this.filters.remark,
          gas_supplier: this.filters.gasCompany,
          pipe_safe: this.filters.safePipe,
          create_man: this.filters.operator,
          is_abnormal: this.filters.status,
      }).then((res) => {
          if (res.result == '200') {
            const data = res.detail.list || [];
            const tableData = data.map(row => ({
              '时间': row.create_time,
              '组名': row.regionname,
              '姓名': row.name,
              '身份': row.identity,
              '联系方式': row.phone,
              '燃气厂家': row.gas_supplier,
              '安心管': row.safePipe || (row.pipe_safe == '0' ? '正常' : '异常'),
              '备注': row.remark,
              '操作员': row.create_man,
              '状态': row.is_abnormal == '0' ? '正常' : '异常',
              '整改时间': row.update_time,
              '照片': row.picpathlist.join(',')
            }));
            const ws = XLSX.utils.json_to_sheet(tableData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '整改记录');
            const wbOut = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([wbOut], { type: 'application/octet-stream' });
            const now = new Date();
            const ts = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}_${String(now.getHours()).padStart(2,'0')}${String(now.getMinutes()).padStart(2,'0')}${String(now.getSeconds()).padStart(2,'0')}`;
            FileSaver.saveAs(blob, `燃气整改记录_${ts}.xlsx`);
            this.$message.success('导出成功');
          } else {
            this.$message.error(res.description || '导出失败');
          }
      }).finally(() => {
          this.exporting = false;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./variables.scss";
// ========== Layout ==========
.query-page {
  background-color: $page-bg;
  padding: 12px;
  min-height: calc(100vh - 100px);
  box-sizing: border-box;
}


.page-title {
    font-size: $font-size-xl;
    font-weight: 600;
    color: $text-primary;
    margin-bottom: $spacing-lg;
  }

// ========== Filter Section ==========
.filter-section {
  background: $card-bg;
  border-radius: $radius-md;
  padding: $spacing-lg;
  box-shadow: $shadow-sm;
  margin-bottom: $spacing-lg;
}

// ========== Table Section ==========
.table-section {
  background: $card-bg;
  border-radius: $radius-md;
  padding: $spacing-lg;
  box-shadow: $shadow-sm;

  .pagination-wrapper {
    margin-top: $spacing-lg;
    text-align: center;
  }
}

// ========== Table Header Style ==========
:deep(.table-header-cell) {
  font-weight: 600;
  color: $text-secondary;
  background: $table-header-bg;
}
</style>
